import { render, staticRenderFns } from "./OfficeListPage.vue?vue&type=template&id=07b8befc&"
import script from "./OfficeListPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports